function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2825",
    d: "M41 71a30 30 0 1 0-30-30 30 30 0 0 0 30 30z",
    transform: "translate(-10 -10)",
    style: {
      fill: "#2db324",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2826",
    d: "M56.442 35.75 38.054 53.293l-9.179-8.771",
    transform: "translate(-11.659 -12.273)",
    style: {
      strokeWidth: 3,
      fill: "none",
      stroke: "#2db324",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2827",
    d: "M41 71a30 30 0 1 0-30-30 30 30 0 0 0 30 30z",
    transform: "translate(-10 -10)",
    style: {
      strokeWidth: 2,
      fill: "none",
      stroke: "#2db324",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.4e5a7a54.svg";
export { ForwardRef as ReactComponent };